import { Vector2 } from "three";

export default class MouseMgr {
    constructor(props) {
        this.props = props;
        this.mouseMoved = false;
        this.coords = new Vector2();
        this.coords_old = new Vector2();
        this.diff = new Vector2();
        this.timer = null;
        this.count = 0;
        this.init();
    }
    init() {
        if(true || this.props.allowCursor){
            document.body.addEventListener("mousemove", this.onMouseMove.bind(this), false);
            // document.body.addEventListener("touchstart", this.onTouchMove.bind(this), false);
            // document.body.addEventListener("touchmove", this.onTouchMove.bind(this), false);
        }
    }
    setCoords(e, t) {
        this.timer && clearTimeout(this.timer);
        this.coords.set(e, t);
        this.mouseMoved = true;
        this.timer = setTimeout( () => {
            this.mouseMoved = false
        }, 100);
    }
    onTouchMove(e) {
        const {clientX: t, clientY: i} = e.touches[0];
        this.onMove(t, i);
    }
    onMouseMove(e) {
        const {x: t, y: i} = e;
        this.onMove(t, i);
    }
    onMove(e, t) {
        const i = (e - this.props.common.left) / this.props.common.width * 2 - 1
          , s = -((t - this.props.common.top) / this.props.common.height) * 2 + 1;
        this.setCoords(i, s)
    }
    update() {
        this.diff.subVectors(this.coords, this.coords_old);
        this.coords_old.copy(this.coords);
        this.coords_old.x === 0 && this.coords_old.y === 0 && this.diff.set(0, 0)
    }
}